import React, { useState } from 'react';
import {Box,Divider,Typography} from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import {IconButton} from "@mui/material"
import {useSelector, useDispatch} from 'react-redux';
import {useTheme} from '@mui/material/styles'
import { FileOpen, Remove, TitleRounded } from '@mui/icons-material';

const ResultDetailDialog = ({visible,setVisible,content})=>{

	const theme = useTheme()
	const user = useSelector(state => state?.auth.user);
	const size_sm = useMediaQuery(theme.breakpoints.up('sm'));
    const dispatch = useDispatch()

	const onOpen = () => {
		setVisible(true);
	};
	const onClose = () => {
		setVisible(false);
	};


return(    
	<Dialog open={visible} onClose={onClose} sx={{borderRadius:10,justifyContent:"center",textAlign:"center"}}>
		<DialogTitle sx={{background:theme.palette.background.default}}> 
			<Box width="90%" display="flex" flexDirection="row" justifyContent="flex-start" alignContent="center">
				<IconButton sx={{marginTop:3}}>
					<FileOpen fontSize='small'/>
				</IconButton>					
				<Typography mr={2} mt={4} style={{fontSize:15,fontWeight:400,fontFamily:"dinofans"}}>
					Assessment
				</Typography>		
			</Box>
		</DialogTitle>
		<DialogContent m={theme.spacing(1)} sx={{minWidth:400,justifyContent:"flex-start",alignItems:"flex-start",background:theme.palette.background.default}}>
            {
            content?.test?.map((itm,indx)=>(
                <Box key={indx} width="100%" textAlign="left" alignItems="flex-start" justifyContent="flex-start">
                    <Box m={1}>
                        <Typography  fontSize={12} sx={{color:"gray",fontFamily:"dinofans"}}>
                            Question
                        </Typography>
                        <Typography color="white" ml={1} fontSize={12} sx={{whiteSpace:"pre-wrap"}}>
                            {itm?.question}
                        </Typography>
                    </Box>
                    <Box m={1}>
                        <Typography  fontSize={12} sx={{color:"gray",fontFamily:"dinofans"}}>
                            Answer
                        </Typography>
                        <Typography color="white" ml={1} fontSize={12} sx={{whiteSpace:"pre-wrap"}}>
                            {itm?.candidate_answer}
                        </Typography>
                    </Box>
                    <Box m={1}>
                        <Typography  fontSize={12} sx={{color:"gray",fontFamily:"dinofans"}}>
                            Is Correct ?
                        </Typography>
                        <Typography color={itm?.isCorrect ? "green" :"red"} ml={1} fontSize={12} sx={{whiteSpace:"pre-wrap"}}>
                            {itm?.isCorrect ? "correct" : "failed"}
                        </Typography>
                    </Box>
                    <Box m={1}>
                        <Typography  fontSize={12} sx={{color:"gray",fontFamily:"dinofans"}}>
                            Score
                        </Typography>
                        <Typography color={itm?.isCorrect ? "green" :"red"} ml={1} fontSize={12} sx={{whiteSpace:"pre-wrap"}}>
                            {itm?.score} %
                        </Typography>                        
                    </Box>
                    <Divider sx={{mt:1,mb:1,width:"90%"}}/>
                </Box>
            ))
            }
            <Typography  fontSize={12} sx={{color:"gray",fontFamily:"dinofans"}}>
                Total Score
            </Typography>
            <Typography color="white" fontSize={14} sx={{fontFamily:"dinofans"}}>
                {content?.total_score} %
            </Typography>
		</DialogContent>
	</Dialog>
	)
}

export default ResultDetailDialog;